<template>
  <v-text-field v-bind="$attrs" class="mytextfield ma-0 pa-0" :class="IF.MyFont" :hide-details="hideDetails" :density="density"> </v-text-field>
</template>

<script>
export default {
  props: {
    density: {
      type: String,
      default: "compact",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style>
.mytextfield.v-text-field .v-input__control .v-input__slot,
.myselect.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: block !important;
  align-items: center !important;
}

.mytextfield .v-input__slot .v-label,
.mytextfield .v-input__slot .v-input__append-inner,
.mytextfield .v-input__slot .v-input__prepend-inner {
  align-self: center;
  position: static !important;
  margin: 0px !important;
  padding: auto !important;
}
</style>